<template>
  <el-dialog :close-on-click-modal="false" append-to-body :title="isEdit ? '上传示例' : '查看示例'" :visible.sync="isShow" width="800px">
    <div>
      <span style="margin:0 5px;">示例照片:</span>
      <!-- <el-button round type="primary" @click="clickUpload" v-if='isEdit'>上传</el-button>
      <input ref="input" style="display:none;" @change="change" type="file" accept='image/jpeg' multiple> -->
    </div>
    <!-- <draggable v-model="imgList" chosenClass="chosen" filter=".filter" force-fallback="true" animation="300" class="imgbox" v-show="isEdit">
      <div class="img" v-for="(url, index) in imgList" :key="url">
        <div class="del" v-show='isEdit' @click="del(index)">
          <i class="el-icon-close"></i>
        </div>
        <el-image :src="url" fit="cover" :preview-src-list="imgList"></el-image>
      </div>
    </draggable> -->
    <div class="imgbox" v-show="!isEdit">
      <div class="img" v-for="(url, index) in imgList" :key="url">
        <div class="del" v-show='isEdit' @click="del(index)">
          <i class="el-icon-close"></i>
        </div>
        <el-image :src="url" fit="cover" :preview-src-list="imgList"></el-image>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="hide()">取 消</el-button>
      <el-button type="primary" @click="save()">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { templateGetExample, templateSetExample } from '@/api/auxx.js'
import { getExample } from '@/api/pms.js'
import uploadWebImg from '@/utils/uploadWebImg'
// import draggable from 'vuedraggable'
export default {
  // components: {
  //   draggable
  // },
  data () {
    return {
      isShow: false,
      isEdit: false,
      imgList: [],
      templateId: ''
    }
  },
  created () {
    if (this.$checkAwsSdk('product')) this.$store.dispatch('awsSdk/getAwsSdk', 'product')
  },
  methods: {
    show (id, isEdit) {
      this.isEdit = isEdit
      this.isShow = true
      this.templateId = id
      this.templateGetExample()
    },
    hide () {
      this.isShow = false
    },
    templateGetExample () {
      getExample(this.templateId).then(res => {
        let list = res.data.data.map((item, index) => {
          let aa = item.templates.map((a, b) => {
            return a.templateThumbnail
          })
          return aa
        }, [])
        this.imgList = list
      })
      // templateGetExample(this.templateId)
      //   .then(res => {
      //     let list = res.data.data.reduce((list, item) => {
      //       list[item.sorting] = item.url
      //       return list
      //     }, [])
      //     this.imgList = list
      //   })
    },
    save () {
      if (!this.isEdit) {
        this.hide()
        return
      }
      let vo = {
        exampleVoList: [],
        templateId: this.templateId
      }
      this.imgList.forEach((url, index) => {
        vo.exampleVoList.push({
          sorting: index,
          url: url
        })
      })
      templateSetExample(vo)
        .then(res => {
          if (res.data.success) {
            this.$message.success('设置成功')
            this.hide()
          }
        })
    },
    del (index) {
      this.imgList.splice(index, 1)
    },
    clickUpload () {
      this.$refs.input.click()
    },
    change (e) {
      console.log(e.target.files)
      let files = e.target.files
      files.forEach(file => {
        uploadWebImg(file, this.$store.state.awsSdk.product.s3).then(res => {
          this.imgList.push(res)
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.imgbox {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;

  .img {
    width: 200px;
    // height: 200px;
    margin-right: 10px;
    position: relative;
  }

  .del {
    width: 20px;
    height: 20px;
    background: #ccc;
    position: absolute;
    z-index: 5;
    top: 0;
    right: 0;
    cursor: pointer;
  }

  .el-icon-close {
    font-size: 20px;
  }
}
</style>
